import {
  enumLabel,
  formatRateGuarantee,
  INCLUSION_LABELS,
  isSentinel,
  sentinelLabel,
} from "./shared";

const currency2 = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const formatCurrencyWithDecimals = (value: unknown): string => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "";
  return currency2.format(num);
};

/**
 * FML benefit type+amount field.
 * Types: additionalDollarAmount (show $X), includedInBasePrice, notIncluded.
 */
const fmlBenefit =
  (typeKey: string, amountKey: string) =>
  (row: Record<string, unknown>): string => {
    const type = row[typeKey];
    if (isSentinel(type)) return sentinelLabel(type as string);
    if (type === "includedInBasePrice") return "Included in Base Price";
    if (type === "additionalDollarAmount")
      return formatCurrencyWithDecimals(row[amountKey]) || "";
    return "";
  };

const freeText =
  (fieldKey: string) =>
  (row: Record<string, unknown>): string => {
    const value = row[fieldKey];
    return typeof value === "string" ? value : "";
  };

const fmlFormatters: Record<string, (row: Record<string, unknown>) => string> =
  {
    federalFmla: fmlBenefit("federalFmlaType", "federalFmlaAmount"),
    unpaidStateLeaves: fmlBenefit(
      "unpaidStateLeavesType",
      "unpaidStateLeavesAmount",
    ),
    militaryUserra: fmlBenefit("militaryUserraType", "militaryUserraAmount"),
    juryDuty: fmlBenefit("juryDutyType", "juryDutyAmount"),
    ada: fmlBenefit("adaType", "adaAmount"),
    historyAndTakeover: freeText("historyAndTakeover"),
    companyLeaves: freeText("companyLeaves"),
    correspondence: freeText("correspondence"),
    integratedStdFmlaClaimIntake: enumLabel(
      "integratedStdFmlaClaimIntake",
      INCLUSION_LABELS,
    ),
    rateGuarantee: formatRateGuarantee,
  };

export const formatFmlField = (
  fieldId: string,
  row: Record<string, unknown>,
): string | undefined => {
  const formatter = fmlFormatters[fieldId];
  return formatter ? formatter(row) : undefined;
};
